import { BasePack } from 'types';

export const fakePackRepack = {
    guid: 'fake-guid',
    artworkUrl: 'fake-artworkUrl',
    backgroundColor: 'fake-backgroundColor',
    foregroundColor: 'white',
    isExclusive: false,
    isFavorited: false,
    isDownloaded: false,
    name: 'fake-name',
    slug: 'fake-slug',
    type: 'Pack',
} as BasePack;
